import api from './api';
import { League, ApiResponse } from '../types';

const leagueService = {
  getAllLeagues: async (page = 1, limit = 20): Promise<ApiResponse<League[]>> => {
    try {
      const response = await api.get<ApiResponse<League[]>>(`/leagues?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getLeagueById: async (leagueId: number): Promise<League> => {
    try {
      const response = await api.get<League>(`/leagues/${leagueId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getLeaguesByCountry: async (country: string): Promise<League[]> => {
    try {
      const response = await api.get<League[]>(`/leagues/country/${encodeURIComponent(country)}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getPopularLeagues: async (): Promise<League[]> => {
    try {
      const response = await api.get<League[]>('/leagues/popular');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  searchLeagues: async (query: string): Promise<League[]> => {
    try {
      const response = await api.get<League[]>(`/leagues/search?q=${encodeURIComponent(query)}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default leagueService; 